import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import InfoCard from '../components/InfoCard';
import CallToAction from '../components/CallToAction';
import './Home.css';

// Import images
import bannerImage from '../assets/images/banner.jpg';
import ai1 from '../assets/images/ai1.jpg';
import ai2 from '../assets/images/ai2.jpg';
import ai3 from '../assets/images/ai3.jpg';

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>ProgenX - Ana Sayfa | Yapay Zeka Destekli Eğitim Teknolojileri 2025</title>
        <meta name="description" content="ProgenX, yapay zeka destekli eğitim teknolojileri ve yazılım çözümleri sunan yenilikçi bir teknoloji şirketidir. Kişiselleştirilmiş öğrenme deneyimleri, akıllı veri analitiği ve yapay zeka entegrasyonu ile eğitimde dijital dönüşümü hızlandırıyoruz." />
        <meta name="keywords" content="progenx, yapay zeka, eğitim teknolojileri, akıllı veri analizi, yazılım çözümleri, progenx akademi, kişiselleştirilmiş öğrenme, adaptif eğitim, edtech, yapay zeka eğitim" />
        <meta property="og:title" content="ProgenX | Yapay Zeka Destekli Eğitim Teknolojileri" />
        <meta property="og:description" content="Yapay zeka destekli eğitim teknolojileri ve yazılım çözümleri ile geleceği şekillendiriyoruz." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com" />
        <meta property="og:image" content="https://progenxacademy.com/banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ProgenX | Yapay Zeka Destekli Eğitim Teknolojileri" />
        <meta name="twitter:description" content="Yapay zeka destekli eğitim teknolojileri ve yazılım çözümleri." />
        <link rel="canonical" href="https://progenxacademy.com" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX",
            "url": "https://progenxacademy.com",
            "logo": "https://progenxacademy.com/logo.png",
            "description": "Yapay zeka destekli eğitim teknolojileri ve yazılım çözümleri sunan teknoloji şirketi",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "addressCountry": "TR"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-538-686-54-16",
              "contactType": "customer service",
              "email": "info@progenxacademy.com"
            },
            "sameAs": [
              "https://app.progenxacademy.com"
            ]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="PROGENX AKADEMİ" 
        subtitle={'"Geleceği tahmin etmenin en iyi yolu onu oluşturmaktır." -Peter Drucker & Abraham Lincoln'}
        buttonText="Hakkımızda" 
        buttonLink="/hakkinda" 
        backgroundImage={bannerImage}
        isHomePage={true}
      />
      
      <section className="home-intro">
        <div className="container">
          <h2 className="section-title">Hayalindeki Başarıya Adım Adım Yaklaş!</h2>
          <p className="intro-text">
            Progenx, öğrenmenin sınırlarını zorlamak ve başarıya giden yolda her adımda size rehberlik etmek için burada. 
            Yapay zeka destekli yenilikçi çözümlerimizle sorularınıza anında yanıt bulabilir, öğrenmenin gücünü yeniden keşfedebilirsiniz. 
            Zor sorular artık sizin için basit, çünkü her soruya özel çözüm ve öğrenme yolu burada! 
            Başarıya giden bu yolda sizinle birlikte yürümekten gurur duyuyoruz.
          </p>
          
          <div className="card-row">
            <div className="card-column">
              <InfoCard 
                title="Eğitim Teknolojilerinde Yapay Zeka" 
                description="Öğrenmeyi hızlandırmak ve eğitimi daha etkili hale getirmek için yapay zeka destekli eğitim çözümleri sunuyoruz. Her öğrencinin güçlü yönlerini keşfetmesine ve zorluklarını aşmasına yardımcı olan kişiselleştirilmiş programlarımızla, başarıyı kolaylaştırıyoruz. Eğitimde fark yaratmak ve her seviyede en iyi sonuçlara ulaşmak için doğru yerdesiniz."
                image={ai1}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Akıllı Veri Analitiği" 
                description="Veri bilimi ve yapay zeka teknolojilerini birleştirerek, öğrencilerin öğrenme süreçlerini optimize eden analiz araçları geliştiriyoruz. Anında geri bildirim ve özelleştirilmiş içeriklerle, her adımda ilerleme kaydetmek artık çok daha kolay. Başarıya giden yolda her çözüm elimizin altında!"
                image={ai2}
              />
            </div>
            <div className="card-column">
              <InfoCard 
                title="Yazılım ve Yapay Zeka Entegrasyonu" 
                description="Yapay zeka ile yazılımı bir araya getirerek, bireylerin ve kurumların öğrenme yolculuklarında ihtiyaç duyduğu tüm araçları sunuyoruz. Sorulara özel çözümlerden performans analizine kadar geniş bir yelpazede destek sağlıyor, geleceğin liderlerini yetiştirmek için çalışıyoruz. Eğitimde güç sizinle, başarı sizi bekliyor!"
                image={ai3}
              />
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Teknolojiyle Geleceğe Adım Atın, İnovasyonun Gücüyle Tanışın!"
        subtitle="Şimdi bizimle iletişime geçin ve hayallerinizi gerçekleştirelim."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default Home; 